import * as yup from 'yup';
import { MasterImportExecutionForm } from '../../types';

export const getSchema = (): yup.ObjectSchema<MasterImportExecutionForm> =>
  yup.object().shape({
    mastersTypes: yup.string(),
    countries: yup.array(),
    days: yup.number(),
  });
